import React from 'react';
import Card from '../../ui/Card';
import DescriptionPanel from '../../ui/DescriptionPanel';
import { TrendingUpIcon, TrendingDownIcon } from 'lucide-react';
import ChannelSpendDistribution from './ChannelSpendDistribution';
import MonthlySpendTrend from './MonthlySpendTrend';
import LeadGenerationTrend from './LeadGenerationTrend';
import CampaignPerformanceTable from './CampaignPerformanceTable';
import DealerHeatMap from './DealerHeatMap';
import CompetitorRadarChart from './CompetitorRadarChart';
import ContentPerformance from './ContentPerformance';
const MarketingDashboard: React.FC = () => {
  const marketingKPIs = [{
    title: 'Total Marketing Spend',
    value: '₹290 Cr',
    change: '+8.5%',
    isPositive: false,
    subtitle: 'YTD Investment'
  }, {
    title: 'CAC',
    value: '₹3,240',
    change: '-8.2%',
    isPositive: true,
    subtitle: 'Customer Acquisition Cost'
  }, {
    title: 'CPL',
    value: '₹1,850',
    change: '-12.5%',
    isPositive: true,
    subtitle: 'Cost Per Lead'
  }, {
    title: 'Lead Conversion %',
    value: '16.1%',
    change: '+2.3%',
    isPositive: true,
    subtitle: 'Lead to Customer'
  }];
  return <div data-id="element-7757">
      <DescriptionPanel title="Marketing Performance & Market Intelligence" description="Strategic view of marketing effectiveness, campaign performance, and competitive positioning. Track lead generation efficiency, dealer network health, and market share dynamics to optimize marketing investments and drive brand growth." insights={['Digital campaigns delivering 3.2x ROMI - highest across all channels', '16.1% lead-to-customer conversion rate with improving trend', 'CAC reduced by 8.2% through channel optimization', 'ATL spend at 28% of budget driving 35% of brand awareness']} data-id="element-7758" />
      {/* Marketing KPI Row */}
      <div className="mb-8" data-id="element-7759">
        <h2 className="text-xl font-bold text-gray-900 mb-6" data-id="element-7760">
          Marketing Performance Metrics
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-7761">
          {marketingKPIs.map((kpi, index) => <Card key={index} className="p-5 bg-gradient-to-br from-white to-gray-50" data-id="element-7762">
              <div className="flex flex-col h-full" data-id="element-7763">
                <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1" data-id="element-7764">
                  {kpi.title}
                </div>
                <div className="text-xs text-gray-400 mb-3" data-id="element-7765">{kpi.subtitle}</div>
                <div className="text-3xl font-bold text-gray-900 mb-3" data-id="element-7766">
                  {kpi.value}
                </div>
                <div className={`text-sm flex items-center font-semibold ${kpi.isPositive ? 'text-green-600' : 'text-red-600'}`} data-id="element-7767">
                  {kpi.isPositive ? <TrendingUpIcon size={16} className="mr-1" data-id="element-7768" /> : <TrendingDownIcon size={16} className="mr-1" data-id="element-7769" />}
                  {kpi.change} vs last quarter
                </div>
              </div>
            </Card>)}
        </div>
      </div>
      {/* Main Charts Row 1 - Channel Distribution and Monthly Spend */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8" data-id="element-7770">
        <ChannelSpendDistribution data-id="element-7771" />
        <MonthlySpendTrend data-id="element-7772" />
      </div>
      {/* Lead Generation Trend - Full Width */}
      <LeadGenerationTrend data-id="element-7773" />
      {/* Supporting Charts Row */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8" data-id="element-7774">
        <DealerHeatMap data-id="element-7775" />
        <CompetitorRadarChart data-id="element-7776" />
      </div>
      {/* Content Performance */}
      <ContentPerformance data-id="element-7777" />
      {/* Campaign Performance Table */}
      <CampaignPerformanceTable data-id="element-7778" />
    </div>;
};
export default MarketingDashboard;